import axios from 'axios'
import {store} from "./store";

const ApiService = {
    async get(resource) {
        try { 
            const response = await axios.get(resource)
            return response.data;
        } catch (e) {
            console.log(e.message);
            return {
                access_point: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    async post(resource, data) {
        try {
            const response = await axios.post(resource, data)
            return response.data;
        } catch (e) {
            await store.dispatch("setAlert", {type: "error", alert: [e.message]})
        }
    },

    async put(resource, data) {
        try {
            const response = await axios.put(resource, data)
            return response.data;
        } catch (e) {
            await store.dispatch("setAlert", {type: "error", alert: [e.message]})
        }
    },

    async delete(resource) {
        try {
            const response = await axios.delete(resource)
            return response.data;
        } catch (e) {
            await store.dispatch("setAlert", {type: "error", alert: [e.message]})
        }
    },
}

export default ApiService